// extracted by mini-css-extract-plugin
export default {"descTitle":"resetPasswordSentPage_descTitle__bT6FE","firstParagraph":"resetPasswordSentPage_firstParagraph__C29ag","secondParagraph":"resetPasswordSentPage_secondParagraph__wjG-+"};